import { combineReducers } from "redux";
import authReducer from './authReducer';
import leadsReducer from './leadsReducer';
import clientsReducer from './clientsReducer';
import propertiesReducer from './propertiesReducer';
import areasReducer from './areasReducer';
import taskssReducer from './tasksReducer';
import usersReducer from './usersReducer';
import postPropertiesReducer from './postPropertyReducer';
import notificationReducer from './notificationReducer';
import interestedsReducer from "./interestedReducer";
import birthdateReducer from "./birthdateReducer";
import projectsReducer from "./projectsReducer";
import activitiesReducer from "./activitiesReducer";
import leadNotesReducer from "./leadNotesreducer";
import siteVisitDetailsReducer from "./siteVisitDetailsReducer";
import enquiriesReducer from "./enquiriesReducer";
import otpReducer from "./otpReducer";
import preLeadsReducer from "./preLeadsReducer";
const rootReducer = combineReducers({
    auth: authReducer,
    leads: leadsReducer,
    preLeads: preLeadsReducer,
    leadNotes: leadNotesReducer,
    siteVisitDetails: siteVisitDetailsReducer,
    clients: clientsReducer,
    properties: propertiesReducer,
    areas: areasReducer,
    tasks: taskssReducer,
    users: usersReducer,
    postProperties: postPropertiesReducer,
    notifications: notificationReducer,
    interesteds: interestedsReducer,
    birthdate: birthdateReducer,
    projects: projectsReducer,
    activities: activitiesReducer,
    enquiries: enquiriesReducer,
    otps: otpReducer
})

export default rootReducer;